export default __webpack_public_path__ + "6daf0f9d9ec44c1d7e0bd0c4d9ebd0ff.svg";